// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__fxoV9","title":"Info_title__3fZro","links":"Info_links__N8Sjj","link":"Info_link__2Kwuh","logo":"Info_logo__2nTcA"};